import ImageIcon from "@material-ui/icons/Image";
import { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import * as S from "./styles";

function CarouselComponent({ buscaAtual, type, images = [], legend }) {
  const [failedImages, setFailedImages] = useState({});

  const handleImageError = (index) => {
    setFailedImages((prev) => ({ ...prev, [index]: true }));
  };

  const validImages = images.filter((img) => img && img.trim() !== "");

  if (validImages.length === 0) {
    return (
      <S.Wrapper>
        <S.ImagePlaceholder className={type || ""}>
          <ImageIcon />
          <span>Imagem não fornecida</span>
        </S.ImagePlaceholder>
      </S.Wrapper>
    );
  }

  return (
    <S.Wrapper>
      <Carousel
        infiniteLoop={true}
        showThumbs={false}
        width={"100%"}
        fixedWidth
        autoPlay={validImages.length > 1}
        interval={3000}
        stopOnHover={true}
        statusFormatter={(current, total) => `${current} de ${total}`}
        showStatus={validImages.length > 1 ? true : false}
        {...(type ? "centerMode" : "")}
      >
        {validImages.map((image, index) => {
          return (
            <div key={index}>
              {failedImages[index] ? (
                <S.ImagePlaceholder className={type || ""}>
                  <ImageIcon />
                  <span>Imagem não fornecida</span>
                </S.ImagePlaceholder>
              ) : (
                <img
                  className={`image ${type ? type : ""}`}
                  src={image}
                  alt={
                    buscaAtual === "Entretenimento"
                      ? "foto do passeio"
                      : "foto do quarto"
                  }
                  onError={() => handleImageError(index)}
                />
              )}
              {legend ? <p className="legend">{legend}</p> : null}
            </div>
          );
        })}
      </Carousel>
    </S.Wrapper>
  );
}

export default CarouselComponent;
